// getGiftPreviewMeta.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getGiftData from '../selector/getGiftData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import {
  LIVESTREAM_ANIMATION_GIFTS,
  LIVESTREAM_ANIMATION_PAG_GIFTS,
} from '../RemoteConfigKeys.js';

/**
 * Select the minimum gift metadata needed to populate the preview panel and
 * selected-state border. Result is memoized per gift id so it can be safely
 * passed as a prop without breaking shallow comparison.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} id - gift id.
 * @returns {{id: string, image: string, pagImage: string, isPagGift: boolean, isAnimationGift: boolean}|null}
 * @example
 * getGiftPreviewMeta(state, 'rose');
 * // => { id: 'rose', image: '.../rose.png', pagImage: '.../rose.pag', isPagGift: true, isAnimationGift: false }
 */
const getGiftPreviewMeta = createCachedSelector(
  (state, id) => id,
  (state, id) => getGiftData(state, id, 'image'),
  (state, id) => getGiftData(state, id, 'pagImage'),
  state => getRemoteConfigData(state, LIVESTREAM_ANIMATION_GIFTS),
  state => getRemoteConfigData(state, LIVESTREAM_ANIMATION_PAG_GIFTS),
  (id, image, pagImage, animationGiftList, pagGiftList) => {
    if (!id) return null;
    return {
      id,
      image: image || '',
      pagImage: pagImage || '',
      isAnimationGift: animationGiftList.includes(id),
      isPagGift: pagGiftList.includes(id),
    };
  }
)((state, id) => `${id}`);

export default getGiftPreviewMeta;
